<template>
  <div class="container-fluid py-2">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">
                  Grupos de Empresa ({{ paginationData.total || 0 }})
                </h5>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto">
                  <router-link :to="{ name: 'GrupoEmpresa', params: { id: 'new' } }">
                    <button class="mt-1 mb-0 btn btn-outline-success btn-sm mt-sm-0" type="button" name="button">
                      +&nbsp; Novo Grupo de Empresa
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <data-table :items="gruposEmpresa" :columns="columns" :pagination="paginationData" :loading="loading"
              :search-value="search" search-label="Pesquisar Grupo de Empresa" search-placeholder="Descrição"
              @search="onSearch" @page-change="goToPage">
              <!-- Slot personalizado para ações -->
              <template #acoes="{ item }">
                <router-link :to="{ name: 'GrupoEmpresa', params: { id: item.id } }">
                  <button class="btn btn-primary btn-xs" type="button">
                    Editar
                  </button>
                </router-link>
              </template>

              <!-- Slot personalizado para empresas -->
              <template #empresasCount="{ item }">
                <span class="badge bg-gradient-primary empresas-count">
                  {{ item.empresasCount || 0 }}
                </span>
              </template>

              <!-- Slot personalizado para status -->
              <template #status="{ item }">
                <badge-status :ativo="item.status === 1" size="xs" />
              </template>

              <!-- Slot personalizado para createdBy -->
              <template #createdBy="{ item }">
                {{ item.createdBy }}
              </template>

              <!-- Slot personalizado para updatedBy -->
              <template #updatedBy="{ item }">
                {{ item.updatedBy || '-' }}
              </template>
            </data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';
import { getDefaultPaginationState, parsePaginationData, getPaginationParams } from '@/utils/pagination';
import DataTable from '@/components/DataTable.vue';
import BadgeStatus from '@/views/pages/components/BadgeStatus.vue';

export default {
  name: "GrupoEmpresas",
  components: {
    DataTable,
    BadgeStatus
  },
  emits: ['search', 'page-change'],
  inject: ['filters'],
  data() {
    return {
      gruposEmpresa: [],
      search: '',
      loading: false,
      page: 1,
      limit: 10,
      paginationData: getDefaultPaginationState(),
      columns: [
        { key: 'id', label: 'ID', headerClass: 'ps-2', class: 'ps-2' },
        { key: 'descricao', label: 'Descrição', headerClass: 'ps-2', class: 'ps-2' },
        {
          key: 'status',
          label: 'Status',
          headerClass: 'text-center',
          class: 'text-center'
        },
        {
          key: 'empresasCount',
          label: 'Empresas',
          headerClass: 'text-center',
          class: 'text-center'
        },
        {
          key: 'createdBy',
          label: 'Criado por',
          headerClass: 'ps-2 hide-on-mobile',
          class: 'ps-2 hide-on-mobile'
        },
        {
          key: 'createdAt',
          label: 'Criado em',
          formatter: this.formatDate,
          headerClass: 'ps-2',
          class: 'ps-2'
        },
        {
          key: 'updatedBy',
          label: 'Atualizado por',
          headerClass: 'ps-2 hide-on-mobile',
          class: 'ps-2 hide-on-mobile'
        },
        {
          key: 'updatedAt',
          label: 'Atualizado em',
          formatter: this.formatDate,
          headerClass: 'ps-2 hide-on-mobile',
          class: 'ps-2 hide-on-mobile'
        },
        {
          key: 'acoes',
          label: 'Ações',
          headerClass: 'text-center',
          class: 'text-center'
        }
      ]
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;

      // Obter parâmetros de paginação usando a utility
      const params = getPaginationParams(this.page, this.limit, this.search);

      api.get('/grupo-empresas', { params })
        .then(response => {
          const { data } = response;

          // Atualizar os dados paginados usando a utility
          this.gruposEmpresa = data.items;
          this.paginationData = parsePaginationData(data);

          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    onSearch(value) {
      this.search = value;
      this.page = 1;
      this.fetchData();
    },
    goToPage(page) {
      if (page < 1 || page > this.paginationData.totalPages) {
        return;
      }

      this.page = page;
      this.fetchData();

      // Scroll para o topo da tabela quando mudar de página
      window.scrollTo(0, 0);
    },
    formatDate(date) {
      if (!date) return '-';
      return this.filters.formatDateTime(date, 'DD/MM/YY HH:mm');
    }
  }
}
</script>

<style scoped>
.pagination {
  cursor: pointer;
}

.badge {
  font-size: 14px !important;
  padding: 6px 10px !important;
  border-radius: 6px !important;
  font-weight: 600 !important;
}

.empresas-count {
  min-width: 30px;
  display: inline-block;
  box-shadow: 0 2px 5px rgba(50, 50, 93, 0.15);
}

.status-badge {
  min-width: 80px;
  display: inline-block;
  box-shadow: 0 2px 5px rgba(50, 50, 93, 0.15);
}

/* Responsividade para telas pequenas */
@media (max-width: 992px) {
  ::v-deep .hide-on-mobile {
    display: none;
  }
}
</style>